<template>
	<div class="">
		<div class="chartbox4-s">
			<div :id="mychartID" class="charts01"></div>
			<p><span class="red">{{myoffline}}</span>/<span class="blue">{{myonline}}</span></p>
			<h4>{{mychartName}}</h4>
		</div>
	</div>
</template>
<script>
import echarts from "echarts/lib/echarts"
import 'echarts/map/js/china.js';

export default {
  name: 'app',
  data(){
    return {
		myonline: this.online || 0,
		myoffline: this.offline || 0,
		mylegendData: this.legendData || ['在线','离线'],
		mychartName: this.chartName || "",
		mychartID: this.chartID || "ddd"
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.drawChart();
	  })
	const timer = setInterval(() => {
		this.drawChart();			
	}, 5000);
	this.$once('hook:beforeDestroy', () => {
		clearInterval(timer);
	})
  },
  props:['online','offline','legendData','chartName','chartID'],
  methods: {
	drawChart(){
		// console.log("1111111");
		let chart = this.$echarts.init(document.getElementById(this.mychartID));		
		chart.setOption({
			baseOption:{
				tooltip : {
					show: false,
				trigger: 'item',
				formatter: "{a} <br/>{b} : {c} ({d})"
				},
				grid: {
				top:'10%'
				},
				legend: {
					show:false,
					orient : 'vertical',
					x : 'left',
					y : "2%",
					data:this.mylegendData || ['在线','离线']
				},
				series : [
				{
					name: '',
					type: 'pie',
					radius: ['60%', '80%'],
//		              	  替换后台返回数据
					data:[{
							"value": this.myonline || 0,
							"name": this.mylegendData[0] || ""
						},
						{
							"value": this.myoffline || 0,
							"name": this.mylegendData[1] || ""
						}],
					label: {
						normal: {
							show: false,
							formatter: "{c}",
							position : 'inner'
						}
					},
					itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					},
					normal:{
						//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
						//var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
						color: function (params){
						var colorList = ['#39deff','#ff4e3c'];
						return colorList[params.dataIndex];
						}
					}
					}
				}
				]
			}
	
		});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/chartOne.vue